/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-07-09 11:37:13
 * @LastEditTime : 2020-01-09 16:32:39
 * @LastEditors  : Please set LastEditors
 */
export const UCMapEvent=
{   
    POISurroundOverLay_getSurroundInfoFinished:"event_POISurroundOverLay_getSurroundInfoFinished",

    DrawGeometryOverlay_deleteGeometry:"event_DrawGeometryOverlay_deleteGeometry",

    DrawGeometryOverlay_saveGeometry:"event_DrawGeometryOverlay_saveGeometry",
    
    DrawPolycurveOverlay_event_selectCollectFolderFinished:"DrawPolycurveOverlay_event_selectCollectFolderFinished",
    
    MapRightHandButtonOverlay_event_getPOIInfoFinished:"MapRightHandButtonOverlay_event_getPOIInfoFinished",

    MapRightHandButtonOverlay_event_poiNearSearch:"MapRightHandButtonOverlay_event_poiNearSearch",

    MapRightHandButtonOverlay_event_setRouteStartPoint:"MapRightHandButtonOverlay_event_setRouteStartPoint",

    MapRightHandButtonOverlay_event_setRouteViaPoint:"MapRightHandButtonOverlay_event_setRouteViaPoint",

    MapRightHandButtonOverlay_event_setRouteEndPoint:"MapRightHandButtonOverlay_event_setRouteEndPoint",
    

    UCMap_event_zoomlevelChange:"UCMap_event_zoomlevelChange",


    
}